<template>
  <div class="live-stats">
    <div class="stats-num">{{ totalViews }}</div>
    <div class="stats-info">
      <div class="info-item" v-for="(item, index) in metrics" :key="index">
        <span class="info-label">{{ item.label }}</span>
        <span class="info-value">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiveStats",
  props: {
    totalViews: {
      type: String,
      default: "0",
    },
    metrics: {
      type: Array,
      default: () => [
        { label: "实时在线人数", value: "0" },
        { label: "人均观看时长", value: "00:00:00" },
        { label: "直播间热度", value: "0" },
        { label: "点赞数", value: "0" },
      ],
    },
  },
};
</script>

<style lang="less" scoped>
.live-stats {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .stats-num {
    font-size: 80px;
    font-weight: bold;
    color: #ffffff;
    font-family: electronicFont;
    margin-bottom: 30px;
    letter-spacing: 4px;
  }
  .stats-info {
    width: 100%;
    display: flex;
    justify-content: space-around;
    box-sizing: border-box;
    .info-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      .info-label {
        font-size: 30px;
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 20px;
      }
      .info-value {
        font-size: 40px;
        color: #ffffff;
        font-weight: bold;
        font-family: electronicFont;
      }
    }
  }
}
</style>
